export const TICKET_STATUS_KEYS = ['new', 'open', 'pending', 'resolved', 'closed'] as const

export type TicketStatusKey = (typeof TICKET_STATUS_KEYS)[number]

export type TicketStatusLabels = Record<TicketStatusKey, string>

export const DEFAULT_TICKET_STATUS_LABELS: TicketStatusLabels = {
  new: 'New',
  open: 'Open',
  pending: 'Pending',
  resolved: 'Resolved',
  closed: 'Closed',
}

export const TICKET_STATUS_COLORS: Record<
  TicketStatusKey,
  'informative' | 'success' | 'warning' | 'danger' | 'important'
> = {
  new: 'informative',
  open: 'important',
  pending: 'warning',
  resolved: 'success',
  closed: 'informative',
}

export function isTicketStatusKey(value: string): value is TicketStatusKey {
  return (TICKET_STATUS_KEYS as readonly string[]).includes(value)
}

export function ticketStatusLabel(
  status: string,
  labels: TicketStatusLabels = DEFAULT_TICKET_STATUS_LABELS
): string {
  return isTicketStatusKey(status) ? labels[status] : status
}

export function ticketStatusColor(status: string) {
  return isTicketStatusKey(status) ? TICKET_STATUS_COLORS[status] : TICKET_STATUS_COLORS.new
}
